// import assets
import {
    redHeart,
    heart,
    blueCart,
    cart,
    goldStar,
    star
} from "../../utils/cards-svgs";

const CardStyle1 = ({ item }) => {
    return (
        <div className="card1">
            <div className="card1-img-div">
                <img src={item.img} alt={item.title} className="card1-img" />
                <div className="card1-absolute circle-up">
                    <div className="card-svg-circle">
                        {item.wishList ? (
                            <img
                                src={redHeart}
                                alt="wish list"
                                className="card-svg-img"
                            />
                        ) : (
                            <img
                                src={heart}
                                alt="wish list"
                                className="card-svg-img"
                            />
                        )}
                    </div>
                </div>
                <div className="card1-absolute circle-down">
                    <div className="card-svg-circle">
                        {item.cart ? (
                            <img
                                src={blueCart}
                                alt="cart"
                                className="card-svg-img"
                            />
                        ) : (
                            <img
                                src={cart}
                                alt="cart"
                                className="card-svg-img"
                            />
                        )}
                    </div>
                </div>
            </div>
            <div className="card1-txt-div">
                <div className="stars-div">
                    {[...Array(item.stars)].map(() => (
                        <img src={goldStar} alt="star" className="card-star" />
                    ))}
                    {[...Array(5 - item.stars)].map(() => (
                        <img src={star} alt="star" className="card-star" />
                    ))}
                </div>
                <h3 className="card1-h">{item.title}</h3>
                <a href={item.link} className="card1-link">
                    <span>{item.linkTxt}</span>
                    <div className="arrow-svg"></div>
                </a>
            </div>
        </div>
    );
};

export default CardStyle1;
